/* Independent homepage enhancement; existing cart, search and product scripts are unchanged. */
if (!customElements.get('trendvila-offer')) {
  customElements.define('trendvila-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.panel = this.querySelector('.offer-panel');
      if (!this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.key = `trendvila-offer:${this.dataset.sectionId}`;
      this.triggers = [...this.querySelectorAll('[data-offer-trigger]')];
      this.launcher = this.querySelector('.offer-launcher');
      this.launcher.hidden = false;
      this.triggers.forEach(trigger => trigger.addEventListener('click', event => {
        event.preventDefault();
        this.opener = trigger;
        this.open(true);
      }, options));
      this.querySelector('[data-offer-close]').addEventListener('click', () => this.close(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.stopPropagation();
          this.close();
        }
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) this.close();
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open(false);
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close(false);
      }, options);
      if (this.dataset.autoOpen === 'true' && !window.Shopify?.designMode && !this.wasSeen()) {
        this.timer = setTimeout(() => {
          const focused = document.activeElement;
          const otherPanel = document.querySelector('.cart-drawer.active, .mobile-nav-drawer.is-open, .wishlist-drawer.is-open');
          const search = document.getElementById('SearchPopup');
          const quickView = document.getElementById('QuickViewModal');
          const popupVisible = [search, quickView].some(el => el && getComputedStyle(el).opacity !== '0' && getComputedStyle(el).pointerEvents !== 'none');
          if (!document.hidden && !otherPanel && !popupVisible && !focused?.matches('input, textarea, select, [contenteditable="true"]')) this.open(false);
        }, Number(this.dataset.delay) * 1000);
      }
    }
    wasSeen() {
      try { return sessionStorage.getItem(this.key) === 'seen'; } catch { return false; }
    }
    remember() {
      try { sessionStorage.setItem(this.key, 'seen'); } catch { /* Storage can be disabled. */ }
    }
    open(manual) {
      clearTimeout(this.timer);
      this.panel.hidden = false;
      this.launcher.hidden = true;
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
      if (!window.Shopify?.designMode) this.remember();
      // Automatic offers never steal keyboard focus or lock page scrolling.
      if (manual) this.querySelector('[data-offer-close]').focus({ preventScroll: true });
    }
    close(persist = true) {
      clearTimeout(this.timer);
      const restoreFocus = this.panel.contains(document.activeElement);
      this.panel.hidden = true;
      this.launcher.hidden = false;
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      if (persist && !window.Shopify?.designMode) this.remember();
      if (restoreFocus) (this.opener || this.launcher).focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
